function utagFbAddToWishlist (price, name, type = 'qv_wishlist_add') {

	if (window.top.utag_data && window.top.utag && typeof window.top.utag.link === 'function') {

		window.top.utag.link({
			event_type: type,
			product_price: price || window.top.utag_data.product_price,
			product_name: name || window.top.utag_data.product_name,
			order_currency_code: window.top.utag_data.order_currency_code || 'USD'
		});

	}

}

export default utagFbAddToWishlist;
